/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PredefinedMessageService from '../service';
import { toast } from 'react-toastify';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Link } from 'react-router-dom';
import Pagination from 'components/Pagination';
import ModalConfirmation from '../../../components/Modal/ConfirmationModal';
import { MdEmail } from 'react-icons/md';
import { AiFillMessage } from 'react-icons/ai';

import {
  Container,
  Row,
  Card,
  CardHeader,
  Button,
  CardBody,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from 'reactstrap';

import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../assets/styles/table_custom_style';
import ReactLoader from 'components/Loader';

const PredefinedMessageList = () => {
  const [predefinedMessages, setPredefinedMessages] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchMessages, setSearchMessages] = useState();
  const [idResource, setidResource] = useState();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);

  const getPredefinedMessages = (selectedPage = 1, search = '') => {
    setLoading(true);
    PredefinedMessageService.getAllFilter(selectedPage, search)
      .then((res) => {
        const predefinedMessages = res.data.msgsPredefinidas;
        const quantity = res.data.quantidadeDeMsgsPredefinidas;
        const newActivePage = selectedPage || activePage;
        setPredefinedMessages(predefinedMessages);
        setQuantity(quantity);
        setActivePage(newActivePage);
        setLoading(false);
      })
      .catch((err) => {
        //const { data } = error.response;
        toast.error(err.response.data.message || 'Erro ao listar mensagens!', {
          autoClose: 3000,
          closeOnClick: true
        });
        setLoading(false);
      });
  };

  useEffect(getPredefinedMessages, []);

  const handlePageChange = (activePage) => getPredefinedMessages(activePage);

  const deletePredefinedMessage = (id) => {
    PredefinedMessageService.delete(id)
      .then(() => {
        getPredefinedMessages();
        toast.success('Mensagem deletada!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message || 'Erro ao deletar mensagem!', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setOpenModalConfirmation(false);
        getPredefinedMessages();
      });
  };

  const getMessagesSearch = (event, selectedPage = 1) => {
    const value = event.target.value;
    setSearchMessages(value);
    if (value || value === '') {
      getPredefinedMessages(selectedPage, value);
    }
  };

  const controlDelete = (id) => {
    setOpenModalConfirmation(true);
    setidResource(id);
  };

  return (
    <>
      <SimpleHeader
        setCreate="/admin/predefinedMessage/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Mensagem Predefinida</h3>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="11">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="fas fa-search" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Mensagem"
                          type="text"
                          value={searchMessages || ''}
                          onChange={(event) => getMessagesSearch(event)}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
                <ToolkitProvider
                  data={predefinedMessages}
                  keyField="id"
                  columns={[
                    {
                      dataField: 'title',
                      text: 'Título',
                      sort: true,
                      style: {
                        ...individual_column_style,
                        verticalAlign: 'text-top'
                      },
                      headerStyle: individual_header_style
                    },
                    {
                      dataField: 'message',
                      text: 'Mensagem',
                      sort: true,
                      style: individual_column_style,
                      headerStyle: individual_header_style,
                      formatter: (_, row) => {
                        return (
                          <div
                            style={{
                              width: '100%',
                              wordWrap: 'break-word',
                              whiteSpace: 'normal',
                              overflowWrap: 'break-word',
                              textAlign: 'justify',
                              verticalAlign: 'text-top'
                            }}
                          >
                            {row.message !== '' && row.messageHtml !== '' ? (
                              <>
                                <AiFillMessage color="#4682B4" />
                                <MdEmail
                                  color="#4682B4"
                                  style={{ marginRight: '5px' }}
                                />

                                {row.message}
                              </>
                            ) : row.message !== '' && row.messageHtml === '' ? (
                              <>
                                <AiFillMessage
                                  color="#4682B4"
                                  style={{ marginRight: '5px' }}
                                />
                                {row.message}
                              </>
                            ) : row.message === '' && row.messageHtml !== '' ? (
                              <>
                                <MdEmail
                                  color="#4682B4"
                                  style={{ marginRight: '5px' }}
                                />
                                Mensagem de email
                              </>
                            ) : (
                              ''
                            )}
                          </div>
                        );
                      }
                    },
                    {
                      dataField: 'edit',
                      style: {
                        ...icon_column_style,
                        verticalAlign: 'text-top'
                      },
                      headerStyle: individual_icon_header_style,
                      text: 'Editar',
                      formatter: (_, row) => {
                        return (
                          <Link to={'/admin/predefinedMessage/form/' + row.id}>
                            <Button color="info" size="sm">
                              <li className="fas fa-user-edit"></li>
                            </Button>
                          </Link>
                        );
                      }
                    },
                    {
                      dataField: 'delete',
                      style: {
                        ...icon_column_style,
                        verticalAlign: 'text-top'
                      },
                      headerStyle: individual_icon_header_style,
                      text: 'deletar',
                      formatter: (_, row) => {
                        return (
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => controlDelete(row.id)}
                          >
                            <li className="fas fa-trash"></li>
                          </Button>
                        );
                      }
                    }
                  ]}
                >
                  {(props) => (
                    <div className="py-4 table-responsive">
                      {loading ? (
                        <Row className="justify-content-md-center">
                          <ReactLoader />
                        </Row>
                      ) : (
                        <BootstrapTable
                          {...props.baseProps}
                          bootstrap4={true}
                          bordered={false}
                          classes="align-items-center"
                        />
                      )}
                    </div>
                  )}
                </ToolkitProvider>
                <Pagination
                  activePage={activePage}
                  totalItemsCount={quantity}
                  onChange={handlePageChange.bind(this)}
                />
              </Card>
            </div>
          </div>
        </Row>
      </Container>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={idResource}
        deleteResource={deletePredefinedMessage}
        message={'Tem certeza que deseja excluir a Mensagem predefinida?'}
      />
    </>
  );
};

export default PredefinedMessageList;
